// extracted by mini-css-extract-plugin
export default {"container":"OtpContainer_container__I7qE+"};